import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const aiFindingsActionColumn: ITableColumn = {
  labelPath: 'aiFindingsPage.tableColumns.action',
  propertyKey: 'action',
  colType: TableColumnTypeEnum.TextWithIcon,
  width: 130,
  widthType: WidthType.Pixel,
  isSortable: false,
  iconSrc: 'actionIcon',
  toCapitalize: true,
};

export const aiFindingsTableColumns: ITableColumn[] = [
  {
    labelPath: 'aiFindingsPage.tableColumns.displayName',
    propertyKey: 'displayName',
    colType: TableColumnTypeEnum.Text,
    width: 580,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'displayName',
  },
  {
    labelPath: 'aiFindingsPage.tableColumns.timestamp',
    propertyKey: 'timestamp',
    colType: TableColumnTypeEnum.Text,
    width: 166,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'timestamp',
  },
  {
    labelPath: 'aiFindingsPage.tableColumns.severity',
    propertyKey: 'severity',
    colType: TableColumnTypeEnum.SeverityLabel,
    width: 126,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'severity',
  },
  {
    labelPath: 'aiFindingsPage.tableColumns.labels',
    propertyKey: 'labels',
    colType: TableColumnTypeEnum.Label,
    width: 146,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiFindingsPage.tableColumns.actorName',
    propertyKey: 'actorName',
    colType: TableColumnTypeEnum.Text,
    width: 92,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiAgentStepActivityPage.tableColumns.clientApplication',
    propertyKey: 'clientApplication',
    colType: TableColumnTypeEnum.TextWithIcon,
    width: 132,
    widthType: WidthType.Pixel,
    iconSrc: 'clientApplicationIcon',
    isSortable: false,
  },
  {
    labelPath: 'aiAgentStepActivityPage.tableColumns.threadId',
    propertyKey: 'threadId',
    colType: TableColumnTypeEnum.CopyableText,
    width: 80,
    widthType: WidthType.Pixel,
    isSortable: false,
    withCopyIcon: true,
    iconOnly: true,
  },
  {
    labelPath: 'aiFindingsPage.tableColumns.owasp',
    propertyKey: 'owasp',
    colType: TableColumnTypeEnum.Text,
    width: 230,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'owasp',
  },
  {
    labelPath: 'aiFindingsPage.tableColumns.owaspAsi',
    propertyKey: 'owaspAsi',
    colType: TableColumnTypeEnum.Text,
    width: 200,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiFindingsPage.tableColumns.mitreAttack',
    propertyKey: 'mitreAttack',
    colType: TableColumnTypeEnum.Text,
    width: 660,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'genAiAttack',
  },
];
